module.exports = __webpack_public_path__ + "img/auth-demo.c47fae9f.png";